import React from 'react';
// import './OrdersHistory.scss';

export const MoreOrderedItems = ({ items }) => {
  const orderedItems = Object.keys(items);
  return (
    <ul>
      {orderedItems &&
        orderedItems.map((item, index) => (
          <li key={index}>
            <p>
              {items[item].quantity} x {items[item].name}
            </p>
          </li>
        ))}
    </ul>
  );
};
